// extracted by mini-css-extract-plugin
module.exports = {"cardList":"CardList_cardList__39yKz","userSelectionCard":"CardList_userSelectionCard__1EP9o"};